// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid-overlay-app-parent {
	width: 132px;
	height: 288px;
	padding-left: 16px;
	padding-right: 16px;
}

.grid-overlay-option-text {
    font-size: 12px;
    color: var(--theme-text-color);
}

.grid-overlay-color-picker {
    width: 100% !important;
    margin-left: auto !important;
    margin-right : auto !important;
    margin-top: 8px !important;
    margin-bottom: 8px !important;
}
`, "",{"version":3,"sources":["webpack://./src/asset/style/neoviewer/grid_overlay.css"],"names":[],"mappings":"AAAA;CACC,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;IACI,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;IACtB,4BAA4B;IAC5B,8BAA8B;IAC9B,0BAA0B;IAC1B,6BAA6B;AACjC","sourcesContent":[".grid-overlay-app-parent {\n\twidth: 132px;\n\theight: 288px;\n\tpadding-left: 16px;\n\tpadding-right: 16px;\n}\n\n.grid-overlay-option-text {\n    font-size: 12px;\n    color: var(--theme-text-color);\n}\n\n.grid-overlay-color-picker {\n    width: 100% !important;\n    margin-left: auto !important;\n    margin-right : auto !important;\n    margin-top: 8px !important;\n    margin-bottom: 8px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
